// extracted by mini-css-extract-plugin
module.exports = {"page":"Solution_page__KRxrk"};